import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Card,
  Button,
  Stack,
  Paper,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import DaalchiniLogo from "../../assets/dalchini_logo.png";
import Gift_1 from "../../assets/gift-1.png";
import Gift_2 from "../../assets/gift-2.png";
import arrow_left_circle from '../../assets/arrow-left-circle.png'
import SwipeableTextMobileStepper from "./imagesSliding";
import redirect from '../../assets/redirect.png'

export default function GiftCardScreen() {
  const giftCode = "A23100S5";

  const bannerData = [
    { label: "Gift 1", bannerUrl: Gift_1 },
    { label: "Gift 2", bannerUrl: Gift_2 },
  ];

  const handleCopy = () => {
    navigator.clipboard.writeText(giftCode);
  };

  return (
    <Box
      sx={{
        maxWidth: 420,
        mx: "auto",
        bgcolor: "#F3F5F7",
        minHeight: "100vh",
        p: 2,
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" mb={2} >
      <img src={arrow_left_circle}  style={{width:"30px"}}/>

        <Box sx={{ flex: 1, textAlign: "center" }} display={"flex"} justifyContent={"center"}>
          <img src={DaalchiniLogo} style={{ width: 80 }} />
        </Box>
      </Stack>

      {/* Carousel */}
      <SwipeableTextMobileStepper bannerData={bannerData} />

      {/* Title */}
      <Typography
        textAlign="center"
        fontWeight={700}
        fontSize={20}
        mt={2}
        mb={0.5}
      >
        Daalchini Gift Card
      </Typography>

      <Typography
        textAlign="center"
        fontSize={14}
        color="text.secondary"
        mb={3}
      >
        Enjoy your favorite snacks at any vending machine.
      </Typography>

      {/* Gift Code Box */}
      <Paper
        sx={{
          borderRadius: 3,
          px: 2,
          py: 1.5,
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "1px solid #DDE2E6",
        }}
      >
        <Typography fontWeight={600} fontSize={16}>
          {giftCode}
        </Typography>

        <IconButton
          onClick={handleCopy}
          sx={{
            bgcolor: "#E6F4EE",
            "&:hover": { bgcolor: "#D1F0E3" },
          }}
        >
          <ContentCopyIcon sx={{ fontSize: 18, color: "#00A76F" }} />
        </IconButton>
      </Paper>

      {/* Details Card */}
      <Card sx={{ borderRadius: 3, p: 2.5, mb: 4 }}>
        <Typography fontWeight={700} mb={1.5}>
          Details
        </Typography>

        <Typography fontSize={13} color="text.secondary" lineHeight={1.8}>
          • Validity: This gift card is valid until the expiry date given on app, after which it cannot be redeemed or extended.
          <br /><br />
          • Redemption: This gift card can only be redeemed at Daalchini and cannot be exchanged for cash.
          <br /><br />
          • Limitations: The value of this gift card cannot be used to purchase other gift cards.
          • Loss or Theft: Daalchini is not responsible for lost or stolen gift cards. Protect this card as you would cash.
          <br /><br />
          • Changes: Daalchini reserves the right to amend these terms and conditions at any time without prior notice.
        </Typography>
      </Card>

      {/* Claim Button */}
      <Button
        fullWidth
        variant="contained"
        sx={{
          bgcolor: "#12B76A",
          borderRadius: 3,
          py: 1.8,
          fontWeight: 700,
          fontSize: 16,
          textTransform: "none",
          "&:hover": { bgcolor: "#0EA861" },
        }}
      >
        <img src={redirect} style={{width:"20px"}}/>
        Claim Now
      </Button>
    </Box>
  );
}